import { ResourceAppModule } from "@/shared/app";
import { plmApp } from "../app";
import {
  zastosowanieCategoryResource,
  ZastosowanieCategory,
} from "@megarax/client/src/resources/plm/ZastosowanieCategory";

export const zastosowanieCategoryModule: ResourceAppModule = {
  app: plmApp,
  route: "kategoriaZastosowania",
  title: "Kategorie zastosowań receptur",
  resource: zastosowanieCategoryResource,
  itemConstructor: ZastosowanieCategory,
  iconClass: "fas fa-paint-roller fa-fw",
  formComponent: () => import("./ItemForm.vue"),
  sheetComponent: () => import("./ItemSheet.vue"),
  listComponent: () => import("./ItemList.vue"),
};
